import ROUTE from '@app/navigationApp/routes';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { RootState } from '@app/store/newstore';
import { APPLICATION_STATUS, removeUrlWithoutReload, parseParameters, getParameters, removeQueryFromUrlWithoutReloadV2, emailDefferingFlag } from '@app/utils/utils';
import { useEffect, useLayoutEffect, useState } from 'react';
import { View, ActivityIndicator, Platform } from 'react-native';
import { endpoints } from '@app/api/apis';
import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { updatePartnerParams } from '@app/store/slices/platformSlice';
import { updatePendingRequestDetails, updateCreditDetails, updateUserProfile } from '@app/store/slices/authSlice';
import LogOutUser from '@app/helper/logout';
import { trackEvent } from '@app/utils';
import VoltLogoNew from '../../../assets/Icons/VoltLogoNew';
import { getNextRoute } from '@app/navigationApp/navigationUtil';
import { QUERY_PARAMS } from '@app/configs/constants';
import useIsRedirectionJourney from '@app/hooks/useIsRedirectionJourney';
import { LENDER_ID } from '@app/constants/platformPartners';
import { useTheme } from '@shopify/restyle';
import { Theme } from '@app/theme';
import { updateLMSUserDashboard } from '@app/store/slices/commonSlice';


export enum TARGET_PAGES {
    MANAGE_LIMIT = 'manageLimit',
    ACCOUNT = 'account',
    REPAYMENT = 'payment',
    WITHDRAW = 'withdraw',
    FORECLOSURE = 'foreclosure',
    TRANSACTION = 'transaction',
}

export enum StepperStateToken {
    NOT_STARTED = "NOT_STARTED",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    SKIPPED = "SKIPPED",
    FAILED = "FAILED",
    BLOCKED = "BLOCKED",
    PENDING_CALLBACK = "PENDING_CALLBACK",
    PENDING_MANUAL_VERIFICATION = "PENDING_MANUAL_VERIFICATION",
    PENDING_VERIFICATION = "PENDING_VERIFICATION"
}

export const halfJourneyRoutes = [ROUTE.VERIFY_EMAIL, ROUTE.MF_FETCH_PORTFOLIO, ROUTE.MF_PLEDGE_PORTFOLIO, ROUTE.SET_CREDIT_LIMIT, ROUTE.CHECKING_LIMIT, ROUTE.KYC_PAN_VERIFICATION]

const Loader = ({ navigation }) => {
    const dispatch = useAppDispatch();
    const { shareLinkStepId } = useAppSelector((state: RootState) => state.application);
    const userDetails = useAppSelector((state: RootState) => state.auth?.userDetails);
    const platformParams = useAppSelector((state: RootState) => state.platformParams);
    const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
    const userEmailNotExist = userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail === null;
    const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);
    const isBFLLoan = useAppSelector((state) => state.commonReducer.isBFLLoan);
    const { showHome, platform, isFromBajaj, isFromPhonePe, isMfdShareLink, skipToStep, isPLJ, target, takeToFlexiPay, showPostLoanJourney, trackingId } = platformParams
    const isHalfJourney = halfJourneyRoutes.includes(currentStepName)
    const applicationStatus = userDetails?.linkedApplications[0]?.applicationState
    const isApplicationComplete = applicationStatus === 'COMPLETED'
    const emailDefferingFeatureFlag = emailDefferingFlag();
    const firebaseParams = useAppSelector((state: RootState) => state.firebaseParams);

  const {colors} = useTheme<Theme>()


    const {isHalfRedirectionJourney, isFullRedirectionJourney} = useIsRedirectionJourney();

    const showLogo = false
    const params = Platform.OS === 'web' ? getParameters(window?.location?.href) : {};
    const isPgCallback = params?.uid || '';
    const shouldRedirect = params?.redirect || false;
    const startnew = params?.startnew || false;
    const isBajajLender = userDetails?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase()

    const TARGET_ROUTES = {
        [TARGET_PAGES.ACCOUNT]: ROUTE.USER_PROFILE,
        [TARGET_PAGES.REPAYMENT]: ROUTE.FLEXI_PAY,
        [TARGET_PAGES.WITHDRAW]: ROUTE.WITHDRAW_AMOUNT,
        [TARGET_PAGES.FORECLOSURE]: isBajajLender ? ROUTE.OLD_FORECLOSURE : ROUTE.HOW_TO_CLOSE_ACCOUNT,
    }



    useEffect(() => {
        if (platformParams?.isParamsUpdated && userDetails !== null) {
            const skipToEnterEmail = ['JUPITER', 'BHARAT_PE', 'PARKPLUS', 'TATADIGITAL', 'BHARAT_PE_2', 'PARKPLUS', 'PHONEPE', 'SDK_INVESTWELL', 'LARK', 'FLIPKART'].includes(platform);
            const isFromBharatPe = platform === 'BHARAT_PE';
            const isFromSecondBharatPe = platform === 'BHARAT_PE_2';
            const isFreo = platform === 'FREO';
            const isFromFlipkart = platform === 'FLIPKART'



            const url = window.location.href;
            const params = getParameters(url);
            if (trackingId) {
                trackEvent("PLJ_REDIRECT_USER_TO_APP", { trackingId })
            }
            const digio_autopay_response = params?.digio_autopay_response;
            const digio_agreement_response = params?.digio_agreement_response;
            const kyc_response = params?.kyc_response;
            const kyc_redirect = params?.kyc_redirect;
            const tataMandateCallback = url.toString().includes('mandateCallback');
            const isAlreadyAuthenticatedByAnotherCustomer = params?.[QUERY_PARAMS.OC];
            let utmSource = params?.utm_source;


            


            setTimeout(() => {
                const url = Platform.OS === 'web' ? window.location.href : '';
                const params = Platform.OS === 'web' ? getParameters(url) : {};
                if (applicationStatus === APPLICATION_STATUS.DENIED || applicationStatus === APPLICATION_STATUS.BLOCKED) {
                    navigation.navigate(ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN, { applicationState: applicationStatus })
                }
                else if (digio_autopay_response) {
                    navigation.navigate(ROUTE.DIGIO_MANDATE_SIGN)
                } else if (tataMandateCallback) {
                    navigation.navigate(ROUTE.DIGIO_MANDATE_SIGN)
                } else if (kyc_response) {
                    navigation.navigate(ROUTE.KYC_DIGIO_RESPONSE)
                } else if (url.includes("kyc_redirect")) {
                    navigation.navigate(ROUTE.KYC_DIGIO_REDIRECT)
                } else if (digio_agreement_response) {
                    navigation.navigate(ROUTE.DSP_KFS)
                } else if (startnew) {
                    LogOutUser()
                }
                else if (isMfdShareLink) {
                    const nextRoute = getNextRoute(
                        userDetails?.linkedApplications[0]?.currentStepId,
                        userDetails?.linkedApplications[0]?.applicationState,
                        userDetails?.linkedApplications[0]?.stepStatusMap,
                    );
                    if(isAlreadyAuthenticatedByAnotherCustomer){
                        if(userDetails?.linkedApplications[0]?.currentStepId !== shareLinkStepId){
                            navigation.navigate(ROUTE.MFD_SHARE_LINK_END_JOURNEY);
                        } else {
                            navigation.navigate(ROUTE[nextRoute]);
                        }
                    } else {
                        navigation.navigate(ROUTE.MFD_SHARE_LINK_INIT_AUTH);
                    }
                }
                else if (target) {
                    if(isLMSUser) {
                        dispatch(updateLMSUserDashboard({isLMSUserDashboard:true}))
                    }
                    if(isBFLLoan) {
                       navigation.navigate(ROUTE.HOME);
                       return;
                    }
                    const typedTarget = target as keyof typeof TARGET_ROUTES;
                    if (TARGET_ROUTES[typedTarget]) {
                        if(showHome) {
                            navigation.reset({
                                routes: [{ name: ROUTE.HOME }, { name: TARGET_ROUTES[typedTarget] }],
                            });
                        } else {
                            navigation.reset({
                                routes: [{ name: TARGET_ROUTES[typedTarget] }],
                            });
                        }
                        dispatch(updatePartnerParams({ "target": "" } as any))
                        removeUrlWithoutReload("target")
                    }
                    else {
                        navigation.navigate(ROUTE.HOME);
                    }
                }
                else if (isPgCallback && shouldRedirect) {
                    navigation.navigate(ROUTE.PAYMENT_LOADER);
                }
                else if (isPgCallback) {
                    navigation.navigate(ROUTE.PAYMENT_STATUS, { isPgCallback });
                }
                else if (userDetails?.linkedApplications[0]?.stepStatusMap?.DOCUMENTS === StepperStateToken.PENDING_MANUAL_VERIFICATION) {
                    // not needed as these are not supported anymore
                }
                else if (userDetails?.linkedApplications[0]?.stepStatusMap?.DOCUMENTS === StepperStateToken.FAILED) {
                    // not needed as these are not supported anymore
                }
                else if (skipToStep === 1) {
                    AsyncStorage.getItem("application_id").then((applicationId) => {
                        if (applicationId !== userDetails?.linkedApplications[0]?.applicationId) {
                            axios.get(endpoints.borrowerApplication + applicationId)
                                .then((response) => {
                                    const data = response.data;
                                    navigation.navigate(getNextRoute(data?.currentStepId, data?.applicationState, data?.stepStatusMap));
                                })
                        } else {
                            navigation.navigate(currentStepName);
                        }
                    }).catch((error) => {
                        console.error("Error fetching application_id from AsyncStorage:", error);
                    });
                }
                else if (!showHome) {
                    if (emailDefferingFeatureFlag === false && userEmailNotExist) {
                        navigation.navigate(isPLJ || skipToEnterEmail ? ROUTE.ENTER_EMAIL : ROUTE.VERIFY_EMAIL);
                        return;
                    }
                    if(isHalfRedirectionJourney) {
                        navigation.navigate(ROUTE.REDIRECTION_JOURNEY_SCREEN);
                        return;
                    }
                    if(isFullRedirectionJourney && currentStepName === null) {
                        navigation.navigate(ROUTE.CREDIT_LOADING, {showDownloadAppScreen : true})
                        return;
                    }
                    if((currentStepName === "KYC_DOCUMENTS" || currentStepName === "KYC_PHOTO_VERIFICATION" || currentStepName === "KYC_SUMMARY" || currentStepName === "KYC_ADDITIONAL_DETAILS" || currentStepName === "DIGIO_MANDATE_SIGN")) {
                        navigation.navigate(ROUTE.KYC_STEPPER);
                        return;
                    }
                    if(currentStepName === "MF_PLEDGE_PORTFOLIO") {
                        const response = axios.get(endpoints.checkEnabledRTA + userDetails?.linkedApplications[0]?.applicationId)
                                .then((response) => {
                                    const isFromMFCentral = response?.data?.enabledRtaFlow === "MfCentralFlow"
                                    const mfcFetchStatus = response?.data?.mfcFetchStatus

                                    if (mfcFetchStatus === "IN_PROGRESS") {
                                        navigation.navigate(ROUTE.MFC_FETCH_EVALUTE_FUNDS)
                                    } else if (isFromMFCentral) {
                                        navigation.navigate(ROUTE.MFC_FETCH_ANCHOR)
                                    } else {
                                        navigation.navigate(getNextRoute(currentStepName, userDetails?.linkedApplications[0].applicationState, userDetails?.linkedApplications[0].stepStatusMap));

                                    }
                                    return;
                                })
                                .catch(() => {
                                    navigation.navigate(ROUTE.HOME);
                                    return;
                                })
                        return;
                    }
                    else if (currentStepName) {
                        if (isFromPhonePe && isFromBajaj && !isHalfJourney) {
                            navigation.navigate(ROUTE.REDIRECTION_JOURNEY_SCREEN);
                        }
                        if (isFromPhonePe || isFromSecondBharatPe || isFromBharatPe || isFreo || isFromFlipkart) {
                            if (isHalfJourney || utmSource === 'Phonepe_fj') {
                                // navigation.navigate(currentStepName);
                                const calculatedRoute = getNextRoute(currentStepName, userDetails?.linkedApplications[0].applicationState, userDetails?.linkedApplications[0].stepStatusMap);
                            navigation.navigate(getNextRoute(currentStepName, userDetails?.linkedApplications[0].applicationState, userDetails?.linkedApplications[0].stepStatusMap));
                            }
                            else {
                                navigation.navigate(ROUTE.REDIRECTION_JOURNEY_SCREEN);
                                // navigation.navigate('SPLASH_SCREEN');
                            }
                        }
                        else {
                            const calculatedRoute = getNextRoute(currentStepName, userDetails?.linkedApplications[0].applicationState, userDetails?.linkedApplications[0].stepStatusMap);
                            navigation.navigate(getNextRoute(currentStepName, userDetails?.linkedApplications[0].applicationState, userDetails?.linkedApplications[0].stepStatusMap));
                        }
                    }
                    else if (showPostLoanJourney === false || isFromBharatPe || isFromPhonePe) {
                        navigation.navigate(ROUTE.CREDIT_LOADING, {showDownloadAppScreen : true});
                    }
                    else {
                        if(isLMSUser) {
                            dispatch(updateLMSUserDashboard({isLMSUserDashboard:true}))
                        }
                        navigation.navigate(ROUTE.HOME);
                    }
                }
                else if(isHalfRedirectionJourney) {
                    navigation.navigate(ROUTE.REDIRECTION_JOURNEY_SCREEN);
                    return;
                }
                else if(isFullRedirectionJourney) {
                    navigation.navigate(ROUTE.CREDIT_LOADING);
                    return;
                }
                else if (isLMSUser) {
                    dispatch(updateLMSUserDashboard({isLMSUserDashboard:true}))
                    navigation.navigate(ROUTE.HOME);
                }
                else {
                    if (emailDefferingFeatureFlag === false && isPLJ && userEmailNotExist) {
                        if (showHome) {
                            navigation.reset({
                                routes: [{ name: ROUTE.HOME }, { name: ROUTE.ENTER_EMAIL }],
                            });
                        } else {
                            navigation.reset({
                                routes: [{ name: ROUTE.ENTER_EMAIL }],
                            });
                        }
                    } else if (params?.kyc_response) {
                        navigation.navigate(ROUTE.KYC_DIGIO_RESPONSE)
                    } else if (takeToFlexiPay) {
                        if(isLMSUser) {
                            dispatch(updateLMSUserDashboard({isLMSUserDashboard:true}))
                        }
                        if(showHome){
                            navigation.reset({
                                routes: [{ name: ROUTE.HOME }, { name: ROUTE.FLEXI_PAY }],
                            });
                        } else {
                            navigation.reset({
                                routes: [{ name: ROUTE.FLEXI_PAY }],
                            });
                        }
                    } else {
                        navigation.navigate(ROUTE.HOME);
                    }
                }
                const newurl = window.location.protocol + "//" + window.location.host;
                // window.history.replaceState({ path: newurl }, '', newurl);
            }, 500);
        }
    }, [platformParams?.isParamsUpdated]);
    return (
        <View style={{ backgroundColor: showLogo ? colors['bg-action-primary'] : colors['bg-surface-primary'], flex: 1, alignItems: 'center', justifyContent: 'center' }}>
            {
                showLogo ? <VoltLogoNew /> : <ActivityIndicator size={12} color={colors['icon-action-primary']} />
            }
        </View>
    );
}
export default Loader;